import "./bookingInfoCompo.scss";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Card from "../../components/Card/Card";

const BookingInfoCompo = ({ onClose, onResponse, btnDisbled }) => {
  const [disabled, setDisabled] = useState(false);
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const moreInfo =
    JSON.parse(decodeURIComponent(params.get("moreInfo"))) ||
    onResponse.data.message;

  // const arrivingDate = moreInfo
  //   ? moreInfo.arriving_DateTime.split("T")[0]
  //   : onResponse.data.message.Arriving_DateTime.split("T")[0];
  // const depaturingDate = moreInfo
  //   ? moreInfo.depature_DateTime.split("T")[0]
  //   : onResponse.data.message.Depature_DateTime.split("T")[0];

  const navigate = useNavigate();

  const handleConfirmClick = () => {
    if (btnDisbled) return;
    if (moreInfo) {
      navigate(
        `/addguestdetails?response=${encodeURIComponent(
          JSON.stringify(moreInfo),
        )}`,
      );
    }
  };

  return (
    <div className="containor1">
      <Card
        moreInfo={moreInfo}
        onResponse={onResponse}
        // arrivingDate={arrivingDate}
        // depaturingDate={depaturingDate}
      />

      <div className="bottom-1">
        <button onClick={onClose} className="btn-cancel">
          Cancel
        </button>
        <button
          onClick={handleConfirmClick}
          className="btn-confirm"
          disabled={btnDisbled}
        >
          Confirm
        </button>
      </div>
    </div>
  );
};

export default BookingInfoCompo;
